import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';

// 覆盖鲸海蓝主色调
var getTabsStyle = function getTabsStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary,
    primary5 = _getThemeData.primary5,
    primary7 = _getThemeData.primary7;
  var _getThemeData2 = getThemeData(props, 'tabs'),
    tabFontSize = _getThemeData2.tabFontSize;
  return css([".c7n-tabs.c7n-tabs.c7n-tabs.c7n-tabs{.c7n-tabs-ink-bar{background-color:", ";}.c7n-tabs-tab-active,.c7n-tabs-tab-active .c7n-tabs-tab-count{color:", ";}.c7n-tabs-nav .c7n-tabs-tab{font-size:", "px;}.c7n-tabs-nav .c7n-tabs-tab:hover,.c7n-tabs-second-nav .c7n-tabs-tab:hover,.c7n-tabs-nav .c7n-tabs-tab:hover .c7n-tabs-tab-count,.c7n-tabs-second-nav .c7n-tabs-tab:hover .c7n-tabs-tab-count{color:", ";}.c7n-tabs-nav .c7n-tabs-tab:active,.c7n-tabs-second-nav .c7n-tabs-tab:active,.c7n-tabs-nav .c7n-tabs-tab:active .c7n-tabs-tab-count,.c7n-tabs-second-nav .c7n-tabs-tab:active .c7n-tabs-tab-count{color:", ";}}"], primary, primary, tabFontSize, primary5, primary7);
};
var tabsData = {
  name: 'tabs',
  data: [{
    tabFontSize: 14
  }],
  // 不使用主题5模板，只需要在鲸海蓝基础上修改颜色即可
  onlyTemplate: {
    base: getTabsStyle
  }
};
export default tabsData;